module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='  <div class="headerBar">\n    <div class="headerButtonBar">\n    </div>\n  </div>\n\n  <div class="innerContent validation-info-div">\n      <div id="validationEditor"> </div>\n      <div class="bottomButtonBar">\n        <button id="saveValidationButton" class="pull-right button-success">Save</button>\n      </div>\n  </div>\n';
}
return __p;
};
